export const getInvoiceAllowanceDesc = (
  allowanceLabel: string,
  talentName: string
) => {
  return `Allowance: ${allowanceLabel} for ${talentName}`;
};
